<template>
  <div class="progressContainerMain" :style="cssProps">
    <div class="topBar">
      <!-- <div class="closeBtn" @click="closeUploaderProgress">
        <img src="@/assets/images/close2.png">
      </div> -->
      <div>Dosya yükleme</div>
    </div>
    <div class="loadingTitle">
      Dosyalar yükleniyor...
    </div>
    <div class="fileProgessRowsContainer">
      <div class="progressRowMain" v-for="(fileObj, index) in fileObjs" :key="index + 'PRTU' + fileObj.file.name">
        <FileImage class="thumbImage" :file="fileObj.file" :is-mime="isMime" v-if="!isMime" />
        <FileImage class="mimeImage" :file="fileObj.file" :is-mime="isMime" v-else />
        <div class="progressMidCol">
          <div class="filename">
            {{ fileObj.file.name }}
          </div>
          <div class="progressTrack">
            <div class="progressInd" :style="{ width: fileObj.uploadProgress + '%' }" />
          </div>
        </div>
        <div class="percentMain">
          <div style="flex-grow: 1" />
          <div class="percentNumber" v-if="fileObj.uploadStatus === 2">
            <img src="@/assets/images/tick_green.png" class="okTick">
          </div>
          <div class="percentNumber" v-else>
            <span class="percent">%</span> {{ fileObj.uploadProgress }}
          </div>
        </div>
      </div>
    </div>

    <div class="progressRowMainTotal" v-if="fileObjs.length > 1">
      <div class="progressMidCol">
        <div class="filename">
          Toplam
        </div>
        <div class="progressTrack">
          <div class="progressIndTotal" :style="{ width: totalPercent + '%' }" />
        </div>
      </div>
      <div class="percentMain percentMainTotal">
        <div style="flex-grow: 1" />
        <div class="percentNumberTotal">
          <span class="percent">%</span> {{ totalPercent }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileImage from './image/FileImage.vue'
import EventBus from '@/eventbus.js'

export default {
  props: {
    fileObjs: {
      type: Array,
      default: function () {
        return []
      }
    },
    isMime: Boolean
  },

  computed: {
    cssProps () {
      return {
        '--topBarColor': this.$config.theme.default.previewPage.topBarColor,
        '--fontColor': this.$config.theme.default.previewPage.fontColor,
        '--progressBarColor': this.$config.theme.default.previewPage.progressBarColor
      }
    },
    totalUploaded () {
      var size = 0
      for (let fileObj of this.fileObjs) {
        size = size + fileObj.uploadedSize
      }
      return size
    },

    totalSize () {
      var size = 0
      for (let fileObj of this.fileObjs) {
        size = size + fileObj.fileSize
      }

      return size
    },

    totalPercent () {
      let perc = Math.ceil((this.totalUploaded * 100) / this.totalSize)
      if (perc > 100) {
        perc = 100
      }
      return perc
    },

    isAllFilesUploaded () {
      var result = true
      for (let fileObj of this.fileObjs) {
        if (fileObj.uploadStatus !== 2) {
          result = false
        }
      }

      return result
    }
  },
  methods: {
    closeUploaderProgress () {},
    startUploadingFiles () {
      this.fileObjs.forEach(fileObj => {
        if (fileObj.uploadStatus === 0) {
          EventBus.$emit('heyManagerUploadThisFile', fileObj, 'heyUploaderIveUploadedThisFile')
        }
      })
    },

    // eslint-disable-next-line
      uploadManagerDidSomething(fileObj) {},
    // eslint-disable-next-line
      uploadManagerUploadedFile(fileObj) {}
  },
  components: {
    FileImage
  },

  mounted () {
    this.startUploadingFiles()

    EventBus.$on('heyUploaderIDidSomething', this.uploadManagerDidSomething)
    EventBus.$on(
      'heyUploaderIveUploadedThisFile',
      this.uploadManagerUploadedFile
    )
  },

  beforeDestroy () {
    EventBus.$off('heyUploaderIDidSomething')
    EventBus.$off('heyUploaderIveUploadedThisFile')
  },

  watch: {
    isAllFilesUploaded: {
      // eslint-disable-next-line
        handler: function (val, oldVal) {
        this.$emit('complete')
      },
      deep: false
    }
  }
}

</script>

<style scoped>
  .progressContainerMain {
    background-color: rgba(255, 255, 255, 0.95);
    position: absolute;
    margin: 0;
    width: 100%;
    height: 100%;
    z-index: 999999999999;
    display: flex;
    flex-direction: column;
  }

  .topBar {
    background-color: var(--topBarColor);
    padding: 10px;
    color: white;
    font-weight: 400;
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .closeBtn,
  .closeBtn>img {
    width: 12px;
    height: 12px;
    cursor: pointer;
  }

  .closeBtn {
    margin-right: 10px;
  }

  .fileProgessRowsContainer {
    margin: 30px;
    margin-top: 0px;
    overflow-y: scroll;
    flex-grow: 1;
  }

  .loadingTitle {
    color: var(--fontColor);
    font-size: 14px;
    font-weight: 300;
    margin: 20px;
  }

  .progressRowMain {
    margin: 20px;
    display: flex;
  }

  .progressRowMainTotal {
    margin: 20px;
    display: flex;
    margin: 30px;
    flex-grow: 0;
    flex-shrink: 0;
  }

  .thumbImage {
    width: 120px;
    height: 60px;
    object-fit: cover;
  }

  .mimeImage {
    width: 80px;
    height: 80px;
  }

  .progressMidCol {
    flex-grow: 1;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .filename {
    font-size: 12px;
    padding: 8px;
    padding-left: 0px;
  }

  .progressTrack {
    background-color: #eaeceb;
    height: 10px;
    position: relative;
  }

  .progressInd {
    background-color: var(--progressBarColor);
    height: 10px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .progressIndTotal {
    background-color: #00ce67;
    height: 10px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .percentMain {
    font-weight: 700;
    color: #f22627;
    margin-right: 20px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    width: 80px;
    justify-content: center;
    align-items: center;
  }

  .percentMainTotal {
    color: #00ce67;
  }

  .percent {
    font-weight: 300;
    font-size: 10px;
  }

  .percentNumber {
    font-weight: 700;
    font-size: 20px;
    flex-grow: 0;
    margin-bottom: -4px;
  }

  .percentNumberTotal {
    font-weight: 700;
    font-size: 20px;
    flex-grow: 0;
    margin-bottom: -10px;
  }

  .okTick {
    width: 20px;
    height: 20px;
  }

</style>
